/**
 * Anatomical coordinates for Hijama points (front + back human body)
 * Mapping is approximate — used only for visual reference.
 * SVG viewBox: 0 0 200 520
 */

// Front-view coordinates (x, y) for points visible from the front
export const FRONT_POINTS = {
  6: { x: 78, y: 38, label: "Temple R" },
  7: { x: 122, y: 38, label: "Temple L" },
  8: { x: 100, y: 32, label: "Forehead" },
  11: { x: 100, y: 88, label: "Throat" },
  81: { x: 100, y: 118, label: "Sternum ↑" },
  82: { x: 100, y: 175, label: "Sternum ↓" },
  83: { x: 80, y: 130, label: "Chest UR" },
  84: { x: 120, y: 130, label: "Chest UL" },
  96: { x: 78, y: 158, label: "Chest LR" },
  97: { x: 122, y: 158, label: "Chest LL" },
  85: { x: 76, y: 180, label: "Costal R" },
  86: { x: 124, y: 180, label: "Costal L" },
  87: { x: 100, y: 195, label: "Epigastric" },
  88: { x: 83, y: 200, label: "Hypoch R" },
  89: { x: 117, y: 200, label: "Hypoch L" },
  90: { x: 100, y: 230, label: "Umbilical" },
  91: { x: 80, y: 240, label: "Lumb Ab R" },
  92: { x: 120, y: 240, label: "Lumb Ab L" },
  93: { x: 83, y: 268, label: "Iliac R" },
  94: { x: 117, y: 268, label: "Iliac L" },
  95: { x: 100, y: 278, label: "Hypogastric" },
  98: { x: 65, y: 138, label: "Axil ant R" },
  99: { x: 135, y: 138, label: "Axil ant L" },
  104: { x: 55, y: 175, label: "Biceps R" },
  105: { x: 145, y: 175, label: "Biceps L" },
  108: { x: 50, y: 215, label: "Elbow F R" },
  109: { x: 150, y: 215, label: "Elbow F L" },
  112: { x: 45, y: 245, label: "Forearm R" },
  113: { x: 155, y: 245, label: "Forearm L" },
  116: { x: 42, y: 285, label: "Wrist R" },
  117: { x: 158, y: 285, label: "Wrist L" },
  120: { x: 85, y: 320, label: "Thigh F R" },
  121: { x: 115, y: 320, label: "Thigh F L" },
  124: { x: 95, y: 320, label: "Thigh M R" },
  125: { x: 105, y: 320, label: "Thigh M L" },
  126: { x: 73, y: 320, label: "Thigh L R" },
  127: { x: 127, y: 320, label: "Thigh L L" },
  128: { x: 85, y: 380, label: "Knee F R" },
  129: { x: 115, y: 380, label: "Knee F L" },
  134: { x: 85, y: 420, label: "Shin R" },
  135: { x: 115, y: 420, label: "Shin L" },
  140: { x: 80, y: 462, label: "Ankle Lat R" },
  141: { x: 120, y: 462, label: "Ankle Lat L" },
  142: { x: 90, y: 462, label: "Ankle M R" },
  143: { x: 110, y: 462, label: "Ankle M L" },
  138: { x: 85, y: 490, label: "Foot R ★" },
  139: { x: 115, y: 490, label: "Foot L ★" },
};

// Back-view coordinates
export const BACK_POINTS = {
  1: { x: 100, y: 28, label: "Yafookh ★" },
  5: { x: 100, y: 68, label: "Naqra" },
  2: { x: 80, y: 78, label: "Akhda R ★" },
  3: { x: 120, y: 78, label: "Akhda L ★" },
  9: { x: 73, y: 60, label: "Mastoid R" },
  10: { x: 127, y: 60, label: "Mastoid L" },
  12: { x: 78, y: 92, label: "Neck Lat R" },
  13: { x: 122, y: 92, label: "Neck Lat L" },
  14: { x: 82, y: 108, label: "Trap R" },
  15: { x: 118, y: 108, label: "Trap L" },
  16: { x: 85, y: 78, label: "Suboc R" },
  17: { x: 115, y: 78, label: "Suboc L" },
  20: { x: 100, y: 90, label: "Nape" },
  4: { x: 100, y: 115, label: "Kahil ★" },
  55: { x: 100, y: 115, label: "Kahil ★" }, // alias used in illness data
  21: { x: 73, y: 130, label: "Scap T R" },
  22: { x: 127, y: 130, label: "Scap T L" },
  23: { x: 78, y: 150, label: "Scap C R" },
  24: { x: 122, y: 150, label: "Scap C L" },
  25: { x: 80, y: 175, label: "Scap B R" },
  26: { x: 120, y: 175, label: "Scap B L" },
  27: { x: 100, y: 130, label: "T1-2" },
  28: { x: 100, y: 148, label: "T3-4" },
  29: { x: 100, y: 165, label: "T5-6" },
  30: { x: 100, y: 180, label: "T7-8" },
  31: { x: 85, y: 138, label: "Lung UR" },
  32: { x: 115, y: 138, label: "Lung UL" },
  33: { x: 85, y: 168, label: "Lung LR" },
  34: { x: 115, y: 168, label: "Lung LL" },
  35: { x: 88, y: 148, label: "Rhomb R" },
  36: { x: 112, y: 148, label: "Rhomb L" },
  37: { x: 60, y: 130, label: "Delt R" },
  38: { x: 140, y: 130, label: "Delt L" },
  47: { x: 100, y: 198, label: "T9-10" },
  48: { x: 100, y: 215, label: "T11-12" },
  49: { x: 88, y: 222, label: "Adrenal R" },
  50: { x: 112, y: 222, label: "Adrenal L" },
  51: { x: 100, y: 230, label: "L1" },
  52: { x: 100, y: 240, label: "L2" },
  53: { x: 100, y: 250, label: "L3" },
  54: { x: 100, y: 260, label: "L4" },
  56: { x: 80, y: 232, label: "Kidney R" },
  57: { x: 120, y: 232, label: "Kidney L" },
  58: { x: 72, y: 240, label: "QL R" },
  59: { x: 128, y: 240, label: "QL L" },
  60: { x: 78, y: 275, label: "Glut M R" },
  61: { x: 122, y: 275, label: "Glut M L" },
  62: { x: 88, y: 278, label: "SI R" },
  63: { x: 112, y: 278, label: "SI L" },
  64: { x: 100, y: 285, label: "Sacrum" },
  65: { x: 85, y: 295, label: "Pirif R" },
  66: { x: 115, y: 295, label: "Pirif L" },
  67: { x: 80, y: 305, label: "Glut Mx R" },
  68: { x: 120, y: 305, label: "Glut Mx L" },
  72: { x: 92, y: 250, label: "Lumb Er R" },
  73: { x: 108, y: 250, label: "Lumb Er L" },
  102: { x: 65, y: 138, label: "Axil P R" },
  103: { x: 135, y: 138, label: "Axil P L" },
  106: { x: 55, y: 180, label: "Triceps R" },
  107: { x: 145, y: 180, label: "Triceps L" },
  110: { x: 50, y: 215, label: "Elb P R" },
  111: { x: 150, y: 215, label: "Elb P L" },
  114: { x: 45, y: 245, label: "Forearm E R" },
  115: { x: 155, y: 245, label: "Forearm E L" },
  118: { x: 42, y: 290, label: "Hand R" },
  119: { x: 158, y: 290, label: "Hand L" },
  122: { x: 85, y: 320, label: "Hams R" },
  123: { x: 115, y: 320, label: "Hams L" },
  130: { x: 85, y: 380, label: "Poplit R" },
  131: { x: 115, y: 380, label: "Poplit L" },
  132: { x: 85, y: 420, label: "Calf R" },
  133: { x: 115, y: 420, label: "Calf L" },
  136: { x: 88, y: 462, label: "Achill R" },
  137: { x: 112, y: 462, label: "Achill L" },
};

export const isSunnahPoint = (id) => [1, 2, 3, 4, 55, 138, 139, 162, 163].includes(id);

export const lookupCoords = (id) => {
  if (FRONT_POINTS[id]) return { view: "front", ...FRONT_POINTS[id] };
  if (BACK_POINTS[id]) return { view: "back", ...BACK_POINTS[id] };
  return null;
};
